export function agrilubDetailPage(): string {
  return `
    <div class="min-h-screen">
      <!-- Back navigation -->
      <div class="container-wide py-8">
        <a href="#/projects" class="inline-flex items-center gap-2 font-body font-medium text-body-sm py-2 transition-colors" style="color: var(--color-primary)">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24" aria-hidden="true">
            <path stroke-linecap="round" stroke-linejoin="round" d="M15 19l-7-7 7-7"></path>
          </svg>
          Retour aux projets
        </a>
      </div>

      <!-- Project Hero -->
      <section class="container-wide pb-12 anim-reveal" aria-labelledby="agrilib-title">
        <div class="card overflow-hidden">
          <div class="aspect-[16/9] sm:aspect-[2/1] overflow-hidden" style="background-color: var(--bg-subtle);">
            <img src="${document.querySelector('[data-asset="agrilib-accueil"]')?.getAttribute('src') || ''}"
                 alt="Agrilib - Page d'accueil de la plateforme"
                 class="w-full h-full object-cover"
                 loading="eager"
                 onerror="this.style.display='none'; this.parentElement.innerHTML='<div class=\\'flex items-center justify-center h-full\\' style=\\'color: var(--text-tertiary)\\'>Image indisponible</div>'">
          </div>
          <div class="p-6 sm:p-10">
            <div class="flex flex-wrap gap-2 mb-4">
              <span class="tag">UX/UI Design</span>
              <span class="tag">Web App</span>
              <span class="tag">Mobile</span>
              <span class="tag">Marketplace</span>
            </div>
            <h1 id="agrilib-title" class="font-display font-bold text-display-lg mb-4" style="color: var(--text-primary)">Agrilib</h1>
            <p class="font-body text-body-lg max-w-3xl" style="color: var(--text-secondary)">
              Plateforme de mise en relation et de reservation en ligne entre agriculteurs et prestataires de services agricoles.
            </p>
          </div>
        </div>
      </section>

      <!-- Secondary image -->
      <section class="container-wide pb-12 anim-reveal delay-1" aria-label="Fonctionnalite de recherche">
        <div class="card overflow-hidden">
          <div class="aspect-[16/9] sm:aspect-[2/1] overflow-hidden" style="background-color: var(--bg-subtle);">
            <img src="${document.querySelector('[data-asset="agrilib-recherche"]')?.getAttribute('src') || ''}"
                 alt="Agrilib - Interface de recherche et reservation"
                 class="w-full h-full object-cover"
                 loading="lazy"
                 onerror="this.style.display='none'; this.parentElement.innerHTML='<div class=\\'flex items-center justify-center h-full\\' style=\\'color: var(--text-tertiary)\\'>Image indisponible</div>'">
          </div>
          <div class="p-6 sm:p-8">
            <h2 class="font-display font-bold text-body-lg mb-2" style="color: var(--text-primary)">Systeme de recherche et reservation</h2>
            <p class="font-body text-body-md" style="color: var(--text-secondary)">
              Interface intuitive permettant aux agriculteurs de rechercher et reserver des prestations avec geolocalisation et disponibilites en temps reel.
            </p>
          </div>
        </div>
      </section>

      <!-- Project Details -->
      <section class="container-wide pb-20" aria-label="Details du projet Agrilib">
        <div class="grid md:grid-cols-2 gap-6">

          <!-- Presentation -->
          <div class="card p-6 sm:p-8 anim-reveal delay-2">
            <h2 class="font-display font-bold text-body-lg mb-4" style="color: var(--text-primary)">Presentation du projet</h2>
            <p class="font-body text-body-md mb-3" style="color: var(--text-secondary)">
              <strong style="color: var(--text-primary)">Concept :</strong> Mise en relation agriculteurs / prestataires, reservation en ligne, web + app Android.
            </p>
            <p class="font-body text-body-md mb-4" style="color: var(--text-secondary)">
              <strong style="color: var(--text-primary)">Cibles :</strong> Exploitants agricoles.
            </p>
            <div class="p-4 rounded-xl border-l-4" style="border-color: var(--color-primary); background-color: rgba(67, 56, 202, 0.04);">
              <p class="font-body text-body-sm" style="color: var(--text-secondary)">
                <strong style="color: var(--text-primary)">Portee v1 :</strong> Annuaire geolocalise, fiche prestataire, agenda, reservation, back-office prestataire et admin.
              </p>
            </div>
          </div>

          <!-- Probleme & Objectif -->
          <div class="card p-6 sm:p-8 anim-reveal delay-3">
            <h2 class="font-display font-bold text-body-lg mb-4" style="color: var(--text-primary)">Probleme & Objectif</h2>
            <p class="font-body text-body-md mb-4" style="color: var(--text-secondary)">
              Recherche morcelee, telephones/aller-retour, indisponibilites peu visibles.
            </p>
            <div class="p-4 rounded-xl border-l-4 border-green-500" style="background-color: rgba(34, 197, 94, 0.04);">
              <h3 class="font-display font-semibold text-body-sm mb-2" style="color: var(--text-primary)">Objectifs</h3>
              <ul class="space-y-1 font-body text-body-sm" style="color: var(--text-secondary)" role="list">
                <li>Centraliser l'offre locale</li>
                <li>Afficher des creneaux reels</li>
                <li>Reduire la friction de planification</li>
                <li>Outiller les prestataires</li>
              </ul>
            </div>
          </div>

          <!-- Design & Solutions -->
          <div class="card p-6 sm:p-8 md:col-span-2 anim-reveal delay-4">
            <h2 class="font-display font-bold text-body-lg mb-6" style="color: var(--text-primary)">Design final & Solutions</h2>
            <div class="grid sm:grid-cols-3 gap-4">
              <div class="p-5 rounded-xl" style="background-color: var(--bg-subtle);">
                <h3 class="font-display font-semibold text-body-sm mb-2" style="color: var(--color-primary)">Exploitant</h3>
                <p class="font-body text-body-sm" style="color: var(--text-secondary)">Recherche activite+lieu, liste tri distance/dispo, fiche, choix creneau, confirmation</p>
              </div>
              <div class="p-5 rounded-xl" style="background-color: var(--bg-subtle);">
                <h3 class="font-display font-semibold text-body-sm mb-2" style="color: var(--color-primary)">Prestataire</h3>
                <p class="font-body text-body-sm" style="color: var(--text-secondary)">Onboarding, agenda (creneaux, exceptions), notifications email/SMS, stats</p>
              </div>
              <div class="p-5 rounded-xl" style="background-color: var(--bg-subtle);">
                <h3 class="font-display font-semibold text-body-sm mb-2" style="color: var(--color-primary)">Admin</h3>
                <p class="font-body text-body-sm" style="color: var(--text-secondary)">Moderation profils/categories, gestion communes/zones, support</p>
              </div>
            </div>
          </div>

          <!-- Resultats -->
          <div class="card p-6 sm:p-8 md:col-span-2 anim-reveal delay-5">
            <h2 class="font-display font-bold text-body-lg mb-6" style="color: var(--text-primary)">Resultats & Reflexion</h2>
            <div class="grid sm:grid-cols-3 gap-6 mb-6">
              <div class="text-center">
                <div class="w-12 h-12 rounded-full mx-auto mb-3 flex items-center justify-center" style="background-color: rgba(34, 197, 94, 0.1);">
                  <svg class="w-6 h-6" style="color: #22C55E" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24" aria-hidden="true">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7"></path>
                  </svg>
                </div>
                <p class="font-display font-semibold text-body-sm" style="color: var(--text-primary)">Moins d'appels</p>
                <p class="font-body text-body-sm" style="color: var(--text-tertiary)">Communication simplifiee</p>
              </div>
              <div class="text-center">
                <div class="w-12 h-12 rounded-full mx-auto mb-3 flex items-center justify-center" style="background-color: rgba(67, 56, 202, 0.08);">
                  <svg class="w-6 h-6" style="color: var(--color-primary)" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24" aria-hidden="true">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"></path>
                  </svg>
                </div>
                <p class="font-display font-semibold text-body-sm" style="color: var(--text-primary)">Planning mieux rempli</p>
                <p class="font-body text-body-sm" style="color: var(--text-tertiary)">Optimisation des creneaux</p>
              </div>
              <div class="text-center">
                <div class="w-12 h-12 rounded-full mx-auto mb-3 flex items-center justify-center" style="background-color: rgba(168, 85, 247, 0.08);">
                  <svg class="w-6 h-6" style="color: #A855F7" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24" aria-hidden="true">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"></path>
                    <path stroke-linecap="round" stroke-linejoin="round" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"></path>
                  </svg>
                </div>
                <p class="font-display font-semibold text-body-sm" style="color: var(--text-primary)">Visibilite des creneaux</p>
                <p class="font-body text-body-sm" style="color: var(--text-tertiary)">Disponibilites en temps reel</p>
              </div>
            </div>
            <div class="grid sm:grid-cols-2 gap-4">
              <div class="p-4 rounded-xl border-l-4 border-amber-500" style="background-color: rgba(245, 158, 11, 0.04);">
                <h3 class="font-display font-semibold text-body-sm mb-2" style="color: var(--text-primary)">Risques identifies</h3>
                <ul class="space-y-1 font-body text-body-sm" style="color: var(--text-secondary)" role="list">
                  <li>Adoption lente</li>
                  <li>Disponibilites incompletes</li>
                  <li>Couverture inegale</li>
                </ul>
              </div>
              <div class="p-4 rounded-xl border-l-4" style="border-color: var(--color-primary); background-color: rgba(67, 56, 202, 0.04);">
                <h3 class="font-display font-semibold text-body-sm mb-2" style="color: var(--text-primary)">Mesures correctives</h3>
                <ul class="space-y-1 font-body text-body-sm" style="color: var(--text-secondary)" role="list">
                  <li>Onboarding assiste + import creneaux</li>
                  <li>Rappels SMS/email</li>
                  <li>Pilotes par departement</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- CTA -->
      <section class="py-20 sm:py-28" style="background-color: var(--bg-subtle);" aria-labelledby="agrilib-cta">
        <div class="container-narrow text-center anim-reveal">
          <span class="section-label">Collaboration</span>
          <h2 id="agrilib-cta" class="font-display font-bold text-display-lg mb-4" style="color: var(--text-primary)">Interesse par ce projet ?</h2>
          <p class="font-body text-body-lg mb-10 max-w-lg mx-auto" style="color: var(--text-secondary)">Discutons de vos besoins en design</p>
          <a href="mailto:arthur.miconnet1@gmail.com" class="btn-primary">
            <span>Me contacter</span>
            <svg class="w-4 h-4" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24" aria-hidden="true">
              <path stroke-linecap="round" stroke-linejoin="round" d="M17 8l4 4m0 0l-4 4m4-4H3"></path>
            </svg>
          </a>
        </div>
      </section>
    </div>
  `;
}
